import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';

import { LoaderService, RequestIdent } from './loader.service';
import { Observable } from 'rxjs';
import { env } from '../../../environments/env';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private count = 0;

  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.loaderService.ignoreResource(req.url)) {
      return next.handle(req);
    }
    const request: RequestIdent = {
      id: this.count,
      time: Date.now(),
      url: req.url,
    };
    this.loaderService.addRequest(request);
    this.count++;
    return new Observable((observer) => {
      const subscription = next.handle(req).subscribe(
        (event) => {
          if (event instanceof HttpResponse) {
            this.loaderService.removeRequest(request);
            if (this.isApiRequest(req.url)) {
              this.loaderService.setBackendReachable(true);
            }
          }
          observer.next(event);
        },
        (err: HttpErrorResponse) => {
          this.loaderService.removeRequest(request);
          if (this.isApiRequest(req.url) && this.shouldMarkBackendUnreachable(err)) {
            // Don't flip offline on a single failure. Confirm with a check-update probe first.
            this.loaderService.reportPossiblyUnreachable();
          }
          observer.error(err);
        },
        () => {
          this.loaderService.removeRequest(request);
          observer.complete();
        },
      );
      return () => {
        subscription.unsubscribe();
        this.loaderService.removeRequest(request);
      };
    });
  }

  private isApiRequest(url: string): boolean {
    const baseApiUrl = env.get().api.url;
    return !!baseApiUrl && url.startsWith(baseApiUrl);
  }

  private shouldMarkBackendUnreachable(err: HttpErrorResponse): boolean {
    return err.status === 0 || err.status === 502 || err.status === 503 || err.status === 504;
  }
}
